// TO DO: need to chage all places that use this
export const ALL_TEAMS = {
  id: 'all-teams',
  name: 'All Teams',
  initials: 'ALL',
  ignoreMaxLimit: true
};
